export const INVALID_SUBSCRIBER_ERROR_CODE = 'session_invalid_no_subscriber';
